import React from 'react'
import PropTypes from 'prop-types'
import { Box, Chip, Typography } from '@material-ui/core'
import { Compass as CompassIcon } from 'react-feather'

import FilenameChip from '../../../../../FilenameChip'

import constants from 'constants/index'
import useStyles from './styles'

const OverlayCard = ({ overlay }) => {
  const { OVERLAY_LABEL } = constants.dai.disputes

  const classes = useStyles()
  const overlayLabel =
    OVERLAY_LABEL[overlay.overlay_type] || overlay.overlay_type

  return (
    <Box className={classes.findingCard}>
      <Box className={classes.findingTitle}>
        <CompassIcon size={14} />
        <Typography className={classes.findingTitleText}>
          {overlayLabel}
        </Typography>
        <Chip
          size="small"
          label={overlay.found ? 'Confirmado' : 'Não confirmado'}
          className={classes.overlayBadge}
        />
      </Box>

      {overlay.details && (
        <Typography className={classes.findingText}>
          {overlay.details}
        </Typography>
      )}

      {overlay.supporting_file && (
        <>
          <Typography className={classes.findingSubLabel}>
            Arquivo de apoio
          </Typography>
          <Box className={classes.evidencesRow}>
            <FilenameChip filename={overlay.supporting_file} />
          </Box>
        </>
      )}
    </Box>
  )
}

OverlayCard.propTypes = {
  overlay: PropTypes.object.isRequired,
}

export default OverlayCard
